import React from "react";
import { Helmet } from "react-helmet";
import "./Legal.css";

export const AcceptableUse = () => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const pageUrl = `${origin}/acceptable-use`;
  const description = "FlintHost Acceptable Use Policy for all hosted games.";
  return (
    <div className="legal-page">
      <Helmet>
        <title>FlintHost | Acceptable Use</title>
        <meta name="description" content={description} />
        <meta property="og:title" content="FlintHost | Acceptable Use" />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={`${origin}/img/Logo2.png`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="FlintHost | Acceptable Use" />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={`${origin}/img/Logo2.png`} />
      </Helmet>
      <div className="legal-hero">
        <p className="legal-eyebrow">Legal</p>
        <h1>Acceptable Use Policy</h1>
        <p>Effective date: 1 January 2026</p>
      </div>
      <div className="legal-nav">
        <a href="/tos">Terms of Service</a>
        <a href="/privacy">Privacy Policy</a>
        <a href="/acceptable-use" aria-current="page">Acceptable Use</a>
        <a href="/refunds">Refund Policy</a>
      </div>
      <div className="legal-content">
        <section className="legal-section">
          <h2>1. Overview</h2>
          <p>
            This policy applies to all FlintHost services, including Minecraft, Hytale, and other supported games.
            You are responsible for ensuring your community, plugins, mods, and users comply with these rules.
          </p>
        </section>
        <section className="legal-section">
          <h2>2. Prohibited activities</h2>
          <ul>
            <li>Illegal content or activity, including piracy or copyright infringement.</li>
            <li>Malware, phishing, credential theft, or unauthorized access attempts.</li>
            <li>Harassment, hate speech, threats, or content that violates applicable law.</li>
            <li>DDoS attacks, network abuse, or excessive resource usage that disrupts others.</li>
            <li>Cryptomining or unrelated commercial workloads not approved by FlintHost.</li>
            <li>Hosting cheats, exploits, or services that harm other game communities.</li>
          </ul>
        </section>
        <section className="legal-section">
          <h2>3. Game-specific rules</h2>
          <p>
            You must comply with the terms of the game publisher (e.g., Mojang/Minecraft, Hypixel Studios/Hytale).
            If a publisher requests action, we may enforce their rules or suspend service.
          </p>
        </section>
        <section className="legal-section">
          <h2>4. Enforcement</h2>
          <p>
            We may investigate suspected violations and take actions including warnings, suspension, data removal,
            or termination. We may cooperate with lawful requests from authorities.
          </p>
        </section>
        <section className="legal-section">
          <h2>5. Reporting</h2>
          <p>
            Report abuse to <a href="mailto:contact@flinthost.com">contact@flinthost.com</a> with relevant logs
            or evidence where possible.
          </p>
        </section>
      </div>
    </div>
  );
};
